<template>
	<div class="flex flex-col items-center">
		<div
			v-if="props.showTitle"
			class="text-primary-600 text-sm text-center font-bold max-w-[215px] w-full px-2.5 pt-2.5 pb-1 bg-primary-50 rounded-t-lg"
		>
			<p>{{ $t('Multiplier') }}</p>
		</div>
		<div class="w-full rounded-full py-1 px-4 bg-white">
			<div class="flex items-center justify-center gap-2.5 sm:gap-3">
				<button
					v-for="option in options"
					:key="option"
					class="transition-all duration-300 flex items-center justify-center text-base size-10 smm:size-12 sm:size-[52px]"
					:class="[
						selected === option
							? 'bg-primary-500 text-white rounded-full shadow-lg font-bold'
							: 'text-black hover:text-primary-500',
					]"
					@click="selected = option"
				>
					{{ option }}€
				</button>
			</div>
		</div>
	</div>
</template>

<script setup lang="ts">
defineOptions({
	name: 'AmountPill',
})

const props = withDefaults(
	defineProps<{
		modelValue?: number
		options?: number[]
		showTitle?: boolean
	}>(),
	{
		modelValue: 1,
		options: () => [],
		showTitle: false,
	},
)

const emit = defineEmits<{
	(e: 'update:modelValue', v: number): void
}>()

const { t: $t } = useI18n()

const selected = computed({
	get: () => props.modelValue ?? props.options[0],
	set: (value: number) => {
		emit('update:modelValue', value)
	},
})
</script>
